<template>
<router-view
  v-if="!unauthenticated"
/>
<div
  v-else
  class="flex items-center justify-center"
>
  <transition name="opacity">
    <button
      v-if="!authModalIsActive"
      @click="openAuthModal"
      type="button"
      class="btn btn-primary btn-rounded"
    >Войти</button>
  </transition>
</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import InjectsSeo from "@/mixins/InjectsSeo";

export default {
  mixins: [InjectsSeo],

  metaInfo() {
    return {
      title: this.getFullPageTitle('Вход в аккаунт'),
    }
  },

  created() {
    if (this.unauthenticated) this.openAuthModal();
  },
  methods: {
    openAuthModal() {
      if (!this.authModalIsActive) this.$store.commit('ui/toggleAuthModal');
    },
  },
  computed: {
    ...mapState({
      authModalIsActive: state => state.ui.authModalIsActive,
    }),
    unauthenticated() {
      return !this.$store.state.auth.token; // The user object might not have been loaded yet.
    },
  },
  watch: {
    unauthenticated(n, o) {
      if (!n && o) {
        if (this.authModalIsActive) this.$store.commit('ui/toggleAuthModal');
      }
    },
  },
}
</script>
